export default {
  showFrequentQuestionsDrawer: false,
  showWelcomeModal: false,
  showTutorialModal: false,
  tutorial: null,
  showStepsBanner: false,
  steps: [
    {
      header: "¡Aprende a usar Wegrou en 8 pasos!",
      title: "Configura tu primera tienda",
      subtitle: "Registra tu primera tienda",
      tutorial: {
        name: "Configura tu primera tienda",
        url: "https://www.youtube.com/embed/wl_onV208t8",
      },
    },
    {
      header: "Ya creaste tu primera tienda, ahora tus productos",
      title: "Agrega un producto",
      subtitle: "Registra tu primer producto para ir llenando tu catálogo",
      tutorial: {
        name: "Agregar producto",
        url: "https://www.youtube.com/embed/wl_onV208t8",
      },
    },
    {
      header: "¡Genial, ya completaste el primer paso!",
      title: "Agrega una zona de reparto",
      subtitle: "Define los lugares de entrega de tus productos",
      tutorial: {
        name: "Agregar zona de reparto",
        url: "https://www.youtube.com/embed/66_b5dWmsVo",
      },
    },
    {
      header: "¡Vas muy bien!",
      title: "Agrega un método de pago",
      subtitle: "Elige los medios de pago que quieres ofrecer",
      tutorial: {
        name: "Agregar método de pago",
        url: "https://www.youtube.com/embed/eQNx8Xy1a-M",
      },
    },
    {
      header: "¡Ya estás listo para activar tu tienda online!",
      title: "Activa tu comercio electrónico",
      subtitle: "Dale a conocer al mundo tu negocio y productos",
      tutorial: {
        name: "Activar comercio electrónico",
        url: "https://www.youtube.com/embed/QjTkrrgFdqE",
      },
    },
    {
      header: "¡Ahora conéctate con Whastapp!",
      title: "Integra Whastapp",
      subtitle: "Sincroniza tus clientes y conversaciones",
      tutorial: {
        name: "Conectar WhatsApp con Wegrou",
        url: "https://www.youtube.com/embed/Bb9HyYGAhJE",
      },
    },
    {
      header: "¡Estás listo para recibir oportunidades de negocio!",
      title: "Crea tu primera Oportunidad",
      subtitle: "Cómo generarlas y volverlas una Orden",
      tutorial: {
        name: "Gestiona tus oportunidades",
        url: "https://www.youtube.com/embed/nKh6G8DdvO4",
      },
    },
    {
      header: "¡Inventarios, cobranzas, mensajes masivos y más!",
      title: "Gestiona tus Ventas",
      subtitle: "Cómo administrar tus pedidos",
      tutorial: {
        name: "Gestiona tus órdenes",
        url: "https://www.youtube.com/embed/XuYI2uZwHHw",
      },
    },
    {
      header: "¡Felicidades, hemos terminado!",
      title: "Aprende todo sobre Wegrou",
      subtitle: "Ingresa al módulo de tutoriales ",
      tutorial: {
        name: "Tutoriales",
        url: "https://www.youtube.com/embed/c-8SSc5YeFQ",
      },
    },
  ],
  notifications: [],
  viewTooltips: {
    business: {
      title: "Completa la información de tu negocio",
      description:
        "Nombre, descripción, Logotipo, Dirección, Teléfono, cuenta de Instagram, Facebook, Número de Whastapp",
      tutorial: {
        name: "Completa la información de tu negocio",
        url: "https://www.youtube.com/embed/GOjtndSryxk",
      },
    },
    products: {
      title: "Crea productos o servicios en tu catálogo",
      description: "Precios, descuentos, administra el inventario, carga las imágenes",
      tutorial: {
        name: "Crea productos o servicios en tu catálogo",
        url: "https://www.youtube.com/embed/wl_onV208t8",
      },
    },
    attributes: {
      title: "Administra Atributos para tus productos",
      description: "Tamaños, Colores, presentaciones y más",
      tutorial: {
        name: "Administra Atributos para tus productos",
        url: "https://www.youtube.com/embed/GOjtndSryxk",
      },
    },
    categories: {
      title: "Administra categorías para tus productos",
      description: "Define tipos de productos para poder clasificarlos en tu tienda",
      tutorial: {
        name: "Administra categorías para tus productos",
        url: "https://www.youtube.com/embed/GOjtndSryxk",
      },
    },
    zones: {
      title: "Administra las zonas de reparto",
      description: "Define los precios de Delivery por país, ciudad o distrito",
      tutorial: {
        name: "Administra las zonas de repartos",
        url: "https://www.youtube.com/embed/66_b5dWmsVo",
      },
    },
    payment_methods: {
      title: "Configura tus métodos de pago",
      description:
        "Configura tu pasarela de mercado pago, culqi, yape y transferencias bancarias para el cobrar en tu tienda",
      tutorial: {
        name: "Configura tus métodos de pago",
        url: "https://www.youtube.com/embed/eQNx8Xy1a-M",
      },
    },
    ecommerce: {
      title: "Crea y Gestiona tu tienda online",
      description: "Publica tu tienda online y administra su apariencia",
      tutorial: {
        name: "Crea y Gestiona tu tienda online",
        url: "https://www.youtube.com/embed/QjTkrrgFdqE",
      },
    },
    whatsapp: {
      title: "Conecta tu número de Whastapp",
      description: "Integra tu whastapp para recibir oportunidades, registrar tus conversaciones y enviar mensajes",
      tutorial: {
        name: "Conecta tu número de Whastapp",
        url: "https://www.youtube.com/embed/Bb9HyYGAhJE",
      },
    },
    opportunities: {
      title: "Recibe y gestiona tus oportunidades",
      description: "Aprende qué canales generan oportunidades, cómo alimentarlas de información y hacerles seguimiento",
      tutorial: {
        name: "Recibe y gestiona tus oportunidades",
        url: "https://www.youtube.com/embed/nKh6G8DdvO4",
      },
    },
    segments: {
      title: "Explota tus segmentos de clientes",
      description: "Envía mensajes masivos a grupos filtrados de contactos",
      tutorial: {
        name: "Explota tus segmentos de clientes",
        url: "https://www.youtube.com/embed/GOjtndSryxk",
      },
    },
    orders: {
      title: "Crea y gestiona pedidos",
      description: "Aprende qué canales generan órdenes, cómo actualizarlas y cómo esto afecta tu inventario",
      tutorial: {
        name: "Crea y gestiona pedidos",
        url: "https://www.youtube.com/embed/XuYI2uZwHHw",
      },
    },
    warehouse: {
      title: "Gestiona tu almacén de productos",
      description: "Gestiona stock de productos por cada almacén, transfiere productos entre almacenes",
      // tutorial: {
      //   name: "Crea y gestiona pedidos",
      //   url: "https://www.youtube.com/embed/XuYI2uZwHHw",
      // },
    },
  },
  frequentQuestions: [
    {
      question: "Completa la información de tu negocio",
      answer: "Nombre, descripción, Logotipo, Dirección, Teléfono, cuenta de Instagram, Facebook, Número de Whastapp",
      detail: "Módulo > Negocio“",
      tutorial: {
        name: "Completa la información de tu negocio",
        url: "https://www.youtube.com/embed/GOjtndSryxk",
      },
    },
    {
      question: "Crea productos o servicios en tu catálogo",
      answer: "Precios, descuentos, administra el inventario, carga las imágenes",
      detail: "Módulo > Catálogo > Productos",
      tutorial: {
        name: "Crea productos o servicios en tu catálogo",
        url: "https://www.youtube.com/embed/wl_onV208t8",
      },
    },
    {
      question: "Administra Atributos para tus productos",
      answer: "Tamaños, Colores, presentaciones y más",
      detail: "Módulo > Catálogo > Atributos",
      tutorial: {
        name: "Administra Atributos para tus productos",
        url: "https://www.youtube.com/embed/GOjtndSryxk",
      },
    },
    {
      question: "Administra categorías para tus productos",
      answer: "Define tipos de productos para poder clasificarlos en tu tienda",
      detail: "Módulo > Catálogo > Categorías",
      tutorial: {
        name: "Administra categorías para tus productos",
        url: "https://www.youtube.com/embed/GOjtndSryxk",
      },
    },
    {
      question: "Administra las zonas de reparto",
      answer: "Define los precios de Delivery por país, ciudad o distrito",
      detail: "Módulo > Catálogo > Zonas",
      tutorial: {
        name: "Administra las zonas de reparto",
        url: "https://www.youtube.com/embed/66_b5dWmsVo",
      },
    },
    {
      question: "Configura tus métodos de pago",
      answer:
        "Configura tu pasarela de mercado pago, culqi, yape y transferencias bancarias para el cobrar en tu tienda",
      detail: "Módulo > Catálogo > Métodos de pago",
      tutorial: {
        name: "Configura tus métodos de pago",
        url: "https://www.youtube.com/embed/eQNx8Xy1a-M",
      },
    },

    {
      question: "Crea y Gestiona tu tienda online",
      answer: "Publica tu tienda online y administra su apariencia",
      detail: "Módulo > Canales > Comercio electrónico",
      tutorial: {
        name: "Crea y Gestiona tu tienda online",
        url: "https://www.youtube.com/embed/QjTkrrgFdqE",
      },
    },
    {
      question: "Conecta tu número de Whastapp",
      answer: "Integra tu whastapp para recibir oportunidades, registrar tus conversaciones y enviar mensajes",
      detail: "Módulo > Canales > Whastapp",
      tutorial: {
        name: "Conecta tu número de Whastapp",
        url: "https://www.youtube.com/embed/Bb9HyYGAhJE",
      },
    },
    {
      question: "Recibe y gestiona tus oportunidades",
      answer: "Aprende qué canales generan oportunidades, cómo alimentarlas de información y hacerles seguimiento",
      detail: "Módulo > Oportunidades",
      tutorial: {
        name: "Recibe y gestiona tus oportunidades",
        url: "https://www.youtube.com/embed/nKh6G8DdvO4",
      },
    },
    {
      question: "Explota tus segmentos de clientes",
      answer: "Envía mensajes masivos a grupos filtrados de contactos",
      detail: "Módulo > Segmentos",
      tutorial: {
        name: "Explota tus segmentos de clientes",
        url: "https://www.youtube.com/embed/GOjtndSryxk",
      },
    },
    {
      question: "Crea y gestiona pedidos",
      answer: "Aprende qué canales generan órdenes, cómo actualizarlas y cómo esto afecta tu inventario",
      detail: "Módulo > Ventas",
      tutorial: {
        name: "Crea y gestiona pedidos",
        url: "https://www.youtube.com/embed/XuYI2uZwHHw",
      },
    },
  ],
};
